import { StyledModal } from '@app/components/modal/Modal';
import useUserActions from '@app/hooks/users/useUserActions';
import type { Client } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type UserDeleteModalProps = ModalProps & {
    title?: string;
    data?: Client;
};

export const ClientDeleteModal = ({
    title = 'Delete Client?',
    data,
    ...props
}: UserDeleteModalProps) => {
    const { deleteUser } = useUserActions();

    return (
        <StyledModal
            title={title}
            mask={{ closable: false }}
            okText="Delete"
            {...props}
            confirmLoading={deleteUser?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteUser.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this Client?</p>
        </StyledModal>
    );
};

export default ClientDeleteModal;
